
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"36","height":"36","viewBox":"0 0 36 36","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M18 33C9.716 33 3 26.284 3 18 3 9.716 9.716 3 18 3c8.284 0 15 6.716 15 15 0 8.284-6.716 15-15 15zm-5.844-18.871c1.033 0 1.87-.764 1.87-1.707 0-.943-.837-1.708-1.87-1.708-1.033 0-1.87.765-1.87 1.708s.837 1.707 1.87 1.707zm-1.442 10.976h3.355v-9.676h-3.355v9.676zm8.064-5.382c0-1.11.525-2.195 1.78-2.195 1.256 0 1.564 1.085 1.564 2.169v5.284h3.34v-5.5c0-3.822-2.259-4.481-3.648-4.481-1.389 0-2.155.47-3.036 1.608v-1.303h-3.35v9.676h3.35v-5.258z","fill":"currentColor"}})])
          )
        }
      }
    